module.exports = __webpack_public_path__ + "static/media/clock_small.6ec4ccda.svg";